import { createSelector } from 'reselect'

import { IOnboardingState } from '../models'

export const selectProcessesProgressData = (state: { onboarding: IOnboardingState }) =>
  state.onboarding.processesProgressData

export const selectProcessesProgressLoadingStatus = createSelector(
  [selectProcessesProgressData],
  ({ status }) => status
)
